import {
  clearAdminSessionToken,
  decodeLocalSession,
  getAdminSessionToken,
} from '../../api/authToken';
import { clearImpersonationSession } from '../../impersonation/utils/impersonationSession';

const listeners = new Set();

function sessionUser() {
  const token = getAdminSessionToken();
  const payload = decodeLocalSession(token);
  if (!payload || payload.kind !== 'admin') return null;
  return {
    uid: payload.uid,
    email: payload.email || null,
    providerData: [{ providerId: 'password' }],
    getIdToken: async () => getAdminSessionToken(),
    getIdTokenResult: async () => ({
      claims: { admin: true },
    }),
  };
}

function notify(user) {
  listeners.forEach((cb) => {
    try {
      cb(user);
    } catch {
      // ignore
    }
  });
}

export function notifyAdminAuthChanged() {
  notify(sessionUser());
}

export const adminAuth = {
  get currentUser() {
    return sessionUser();
  },
  onAuthStateChanged(cb) {
    return onAuthStateChanged(adminAuth, cb);
  },
  async signOut() {
    clearAdminSessionToken();
    clearImpersonationSession();
    notify(null);
  },
};

export { adminAuth as auth };

export function onAuthStateChanged(_auth, cb) {
  cb(sessionUser());
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export async function signOut(authInstance = adminAuth) {
  await authInstance.signOut();
}
